import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {
  valorPendente,
  guiaPendente,
  formatarValor,
  formatarDataFiltro,
} from './helpers';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function celulaTexto(valor) {
  const texto = valor == null ? '' : String(valor).trim();
  if (!texto) return { text: 'Em branco', style: 'pendente' };
  return { text: texto, style: 'tableCell' };
}

function celulaValor(vlr) {
  if (valorPendente(vlr)) return { text: 'Em branco', style: 'pendente' };
  return { text: formatarValor(vlr), style: 'tableCell', alignment: 'right' };
}

function celulaGuia(guia) {
  if (guiaPendente(guia)) return { text: 'Em branco', style: 'pendente' };
  return { text: String(guia).trim(), style: 'tableCell' };
}

export function documentoListagem({
  dados,
  titulo,
  dataIni,
  dataFim,
  codFuncEmissor,
  now,
}) {
  const rows = dados.map(item => [
    { text: item.dataFormatada || '', style: 'tableCell' },
    { text: item.NOMEPAC || '', style: 'tableCell' },
    { text: item.REALIZOU || '', style: 'tableCell' },
  ]);

  return {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [40, 60, 40, 60],
    header: {
      margin: [40, 18, 40, 10],
      columns: [
        {
          width: '*',
          stack: [
            {
              text: 'ICM - Instituto do Coração de Marília',
              bold: true,
              fontSize: 11,
            },
            {
              text: 'Relatório institucional para convênios',
              fontSize: 8,
              color: '#555',
            },
          ],
        },
      ],
    },
    footer: (currentPage, pageCount) => ({
      margin: [40, 10, 40, 18],
      columns: [
        {
          width: '*',
          text: `Emitido em ${now}`,
          fontSize: 8,
          color: '#666',
        },
        {
          width: 'auto',
          text: `Emissor: ${codFuncEmissor}`,
          fontSize: 8,
          color: '#666',
          alignment: 'center',
          margin: [8, 0, 8, 0],
        },
        {
          width: 'auto',
          text: `Página ${currentPage} de ${pageCount}`,
          fontSize: 8,
          color: '#666',
          alignment: 'right',
        },
      ],
    }),
    content: [
      {
        text: titulo,
        style: 'subheader',
        alignment: 'center',
        margin: [0, 0, 0, 6],
      },
      {
        text: `Período: ${dataIni} a ${dataFim}   |   Total: ${dados.length} registros   |   CodFunc: ${codFuncEmissor}`,
        alignment: 'center',
        fontSize: 9,
        color: '#555',
        margin: [0, 0, 0, 12],
      },
      {
        table: {
          headerRows: 1,
          widths: [80, '*', '*'],
          body: [
            [
              { text: 'Data', style: 'tableHeader' },
              { text: 'Paciente', style: 'tableHeader' },
              { text: 'Médico', style: 'tableHeader' },
            ],
            ...rows,
          ],
        },
        layout: {
          fillColor: rowIndex =>
            rowIndex % 2 === 0 && rowIndex !== 0 ? '#f5f5f5' : null,
        },
      },
      {
        text: 'Documento destinado a conferência e envio a convênios.',
        alignment: 'left',
        fontSize: 8,
        color: '#777',
        margin: [0, 10, 0, 0],
      },
    ],
    styles: {
      header: { fontSize: 13, bold: true },
      subheader: { fontSize: 11, bold: true },
      tableHeader: {
        bold: true,
        fontSize: 9,
        fillColor: '#2c3e50',
        color: '#fff',
        alignment: 'center',
      },
      tableCell: { fontSize: 9 },
    },
  };
}

export function documentoGuias({
  dados,
  titulo,
  somentePendentes,
  dataInicial,
  dataFinal,
  codFuncEmissor,
  now,
}) {
  const rows = dados.map(item => [
    { text: item.dataFormatada || '', style: 'tableCell' },
    celulaTexto(item.NOMEPAC),
    celulaTexto(item.NOMEMED),
    celulaTexto(item.DESCPROCEDI),
    celulaTexto(item.SIGLACONV),
    celulaValor(item.VLRLAUDO),
    celulaGuia(item.GUIA),
  ]);

  return {
    pageSize: 'A4',
    pageOrientation: 'landscape',
    pageMargins: [28, 56, 28, 48],
    header: {
      margin: [28, 16, 28, 8],
      columns: [
        {
          width: '*',
          stack: [
            {
              text: 'ICM - Instituto do Coração de Marília',
              bold: true,
              fontSize: 11,
            },
            {
              text: 'Relatório institucional para convênios',
              fontSize: 8,
              color: '#555',
            },
          ],
        },
      ],
    },
    footer: (currentPage, pageCount) => ({
      margin: [28, 8, 28, 16],
      columns: [
        {
          width: '*',
          text: `Emitido em ${now}`,
          fontSize: 8,
          color: '#666',
        },
        {
          width: 'auto',
          text: `Emissor: ${codFuncEmissor}`,
          fontSize: 8,
          color: '#666',
          alignment: 'center',
          margin: [8, 0, 8, 0],
        },
        {
          width: 'auto',
          text: `Página ${currentPage} de ${pageCount}`,
          fontSize: 8,
          color: '#666',
          alignment: 'right',
        },
      ],
    }),
    content: [
      {
        text: titulo,
        style: 'subheader',
        alignment: 'center',
        margin: [0, 0, 0, 4],
      },
      somentePendentes
        ? {
            text:
              'Somente registros com valor em branco ou zerado, ou número da guia em branco.',
            alignment: 'center',
            fontSize: 8,
            color: '#c0392b',
            margin: [0, 0, 0, 4],
          }
        : null,
      {
        text: `Período: ${formatarDataFiltro(
          dataInicial
        )} a ${formatarDataFiltro(dataFinal)}   |   Total: ${
          dados.length
        } registros   |   CodFunc: ${codFuncEmissor}`,
        alignment: 'center',
        fontSize: 9,
        color: '#555',
        margin: [0, 0, 0, 10],
      },
      {
        table: {
          headerRows: 1,
          widths: [58, '*', 100, 90, 52, 62, 70],
          body: [
            [
              { text: 'Data', style: 'tableHeader' },
              { text: 'Paciente', style: 'tableHeader' },
              { text: 'Médico', style: 'tableHeader' },
              { text: 'Procedimento', style: 'tableHeader' },
              { text: 'Convênio', style: 'tableHeader' },
              { text: 'Valor', style: 'tableHeader' },
              { text: 'Nr Guia', style: 'tableHeader' },
            ],
            ...rows,
          ],
        },
        layout: {
          fillColor: rowIndex =>
            rowIndex % 2 === 0 && rowIndex !== 0 ? '#f5f5f5' : null,
        },
      },
      {
        text:
          'Campos em vermelho estão em branco. Valor zerado conta como pendente.',
        alignment: 'left',
        fontSize: 8,
        color: '#777',
        margin: [0, 10, 0, 0],
      },
    ].filter(Boolean),
    styles: {
      subheader: { fontSize: 12, bold: true },
      tableHeader: {
        bold: true,
        fontSize: 8,
        fillColor: '#2c3e50',
        color: '#fff',
        alignment: 'center',
      },
      tableCell: { fontSize: 8 },
      pendente: { fontSize: 8, color: '#c0392b', bold: true },
    },
  };
}

export function abrirPdf(docDefinition) {
  pdfMake.createPdf(docDefinition).open();
}
